"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EMPHASIS", {
  enumerable: true,
  get: function get() {
    return _BaseButton.EMPHASIS;
  }
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseButton = _interopRequireWildcard(require("../../../../forecast-v2/components/controls/buttons/BaseButton"));
var _jsxRuntime = require("react/jsx-runtime");
var disableOnClickIfUsingOnPress = function disableOnClickIfUsingOnPress(onPress, onClick) {
  return onPress && !onClick ? function (event) {
    return event.stopPropagation();
  } : onClick;
};
var Button = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? _BaseButton.EMPHASIS.HIGH : _ref$emphasis,
    disabled = _ref.disabled,
    icon = _ref.icon,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["emphasis", "disabled", "icon", "children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BaseButton.default, _objectSpread({
    emphasis: emphasis,
    disabled: disabled,
    leftIcon: icon
  }, props, {
    onPress: props.onPress,
    onClick: disableOnClickIfUsingOnPress(props.onPress, props.onClick),
    ref: ref,
    children: children
  }));
});
var _default = exports.default = Button;